var _defs, _circle, _g, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 283.46457 283.4646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path239-2",
    "data-name": "path239",
    cx: 141.73229,
    cy: 141.73229,
    r: 141.73229,
    fill: "none"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path239",
    cx: 141.73229,
    cy: 141.73229,
    r: 141.73229,
    fill: "#dfe2e3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "path1522-5",
    cx: 141.73228,
    cy: 252.83371,
    rx: 108.72774,
    ry: 71.77757,
    fill: "#a3abae"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "path1522",
    cx: 141.73229,
    cy: 117.25756,
    rx: 54.36386,
    ry: 59.42211,
    fill: "#a3abae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9565aeebe106e3860d8518ec0284639c.svg";
export { ForwardRef as ReactComponent };